import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';
import { Colors, FontWeight, Breakpoints } from '../../assets/styles';

const useStyles = makeStyles((theme: Theme) => ({
  containerColumn: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    margin: '0 16px',
    maxWidth: '100vw',
    minHeight: '100vh',
    overflow: 'hidden',
    padding: 0,
  },
  root: {
    minHeight: '100vh',
    backgroundColor: Colors.White,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  main: {
    maxWidth: 500,
    margin: 'auto',
    paddingTop: 10,
  },
  zeroLogo: {
    display: 'block',
    margin: '0 auto',
    marginBottom: 32,
    height: 'auto',
    maxWidth: 300,
  },
  title: {
    textAlign: 'center',
    fontSize: 36,
    fontWeight: FontWeight.Bold,
    color: Colors.Blue,
     marginBottom: '24px !important',
    // [theme.breakpoints.down(Breakpoints.XS)]: {
    //   fontSize: 36 * 0.7,
    // },
  },
  note: {
    fontSize: '18px !important',
    textAlign: 'center',
    marginBottom: '40px !important',
    fontWeight: `${FontWeight.Light} !important`,
    color: `${Colors.Gray4} !important`,
  },
  inputMail: {
    marginBottom: '30px !important',
  },
  loginLinkContainer: {
    marginTop: 20,
    textAlign: 'center',
  },
  loginLink: {
    fontWeight: FontWeight.Light,
    fontSize: 15,
    color: Colors.Blue1,
    textDecoration: 'none !important',
  },
  submitButtonStyles: {
    width: 280,
    display: 'block',
    margin: '0 auto',
  },
  resendCode: {
    marginTop: 30,
    textAlign: 'center',
    cursor: 'pointer',
  },
  option: {
    fontSize: 15,
    fontWeight: FontWeight.Light,
    lineHeight: '20px',
    color: Colors.Blue1,
  },
}));

export default useStyles;
